import { useEffect, useState } from "react";
import { useNavigate, useNavigation } from "react-router-dom";
import Toast from "../../components/Toast";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../actions/AuthActions";
import Footer from "../../layouts/footer";

function Login() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);

    const user = useSelector(state => state?.auth?.userData?.user);
    const loading = useSelector(state => state?.loading?.loading);

    const user_permissions = JSON.parse(localStorage.getItem('perm'));
    const userId = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (userId && user_permissions.some(item => item.permission_id == '1')) {
            navigate('/dashboard');
        } else if (userId && user_permissions.some(item => item.permission_id == '37')) {
            navigate('/driver/vehicles')
        } else if (userId && user_permissions.some(item => item.permission_id == '2')) {
            navigate('/investigations')
        } else if (userId && user_permissions == '') {
            Toast.fire({
                icon: 'error',
                title: 'You dont have Permission to access the Portal!'
            })
        } else {
        }
    }, [loading])

    const login = () => {
        if (email == '') {
            Toast.fire({
                icon: 'error',
                title: 'Email is Required'
            })
        } else if (password == '') {
            Toast.fire({
                icon: 'error',
                title: 'Password is Required'
            })
        } else {
            let data = {
                email_address: email,
                password: password
            }
            dispatch(loginUser(data));
        }
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            login();
        }
    }

    return (
        <body className="login">
            <div className="container">
                <div className="grid columns-2 gap-4">
                    {/* <!-- BEGIN: Login Info --> */}
                    <div className="col-xl-12 d-none d-xl-flex flex-column min-vh-screen">

                        {/* <div className="my-auto">
                            <img alt="Rubick Bootstrap HTML Admin Template" className="-intro-x w-1/2 mt-n16" src="images/illustration.svg" />
                            <div className="-intro-x text-white fw-medium fs-4xl lh-base mt-10">
                                A few more clicks to
                                sign in to your account.
                            </div>
                            <div className="-intro-x mt-5 fs-lg text-white text-opacity-70 dark-text-gray-500">Manage all your e-commerce accounts in one place</div>
                        </div> */}
                    </div>
                    {/* <!-- END: Login Info -->
                    <!-- BEGIN: Login Form --> */}
                    <div className="g-col-2 g-col-xl-1 h-screen h-xl-auto d-flex py-5 py-xl-0 my-10 my-xl-0">
                        <div className="my-auto mx-auto bg-white px-5 px-sm-8 py-8 rounded-2 shadow-md shadow-xl-none w-full w-sm-3/4 w-lg-2/4 w-xl-auto">
                            <a href="" className="-intro-x d-flex flex-column align-items-center justify-content-center p-5">
                                <img alt="Rubick Bootstrap HTML Admin Template" className="w-56" src="images/logo.jpg" />
                                {/* <span className="ms-3 fs-xl-3xl"> Garage<span className="fw-medium"> Management</span> </span> */}
                            </a>
                            <h2 className="intro-x fs-2xl text-center text-xl-center">
                                Sign In
                            </h2>
                            <div className="intro-x mt-8">
                                <label for="name" className="form-label">Email :</label>
                                <input onKeyPress={handleKeyPress} type="text" onChange={(e) => setEmail(e.target.value)} className="intro-x login__input form-control py-3 px-4 border-gray-300 d-block" placeholder="Email" />
                                <label for="name" className="form-label mt-3">Password :</label>
                                <input onKeyPress={handleKeyPress} type="password" onChange={(e) => setPassword(e.target.value)} className="intro-x login__input form-control py-3 px-4 border-gray-300 d-block" placeholder="Password" />
                            </div>
                            {/* <div className="intro-x d-flex text-gray-700 dark-text-gray-600 fs-xs fs-sm-sm mt-4">
                                <div className="d-flex align-items-center me-auto">
                                    <input id="remember-me" type="checkbox" className="form-check-input border me-2" />
                                    <label className="cursor-pointer select-none" for="remember-me">Remember me</label>
                                </div>
                                <a href="">Forgot Password?</a>
                            </div> */}
                            <div className="intro-x mt-5 mt-xl-8 text-center text-xl-start w-full">
                                {/* <a href="/dashboard"> */}
                                <button disabled={loading} onClick={login} className="btn btn-elevated-dark py-3 px-4 w-full align-top">{loading ? 'Loading' : 'Log in'}</button>
                                {/* </a> */}
                                {/* <button className="btn btn-outline-secondary py-3 px-4 w-full w-xl-32 mt-3 mt-xl-0 align-top">Sign up</button> */}
                            </div>
                        </div>
                    </div>
                    {/* <!-- END: Login Form --> */}
                </div>
            </div>
            {/* <div className="text-start pt-10 mb-5 ms-4 position-absolute bottom-0" >
                <div class="cursor-pointer w-full d-flex align-items-center justify-content-start z-50">
                    <div class="me-1 text-white fs-base">© </div>
                    <img src="/images/Blue-Worl-Innovation-white-text.png" className="w-8 " alt="" />
                    <div class="text-white fs-base">&nbsp; All Rights Reserved</div>
                </div>
            </div > */}
        </body>
    );
}

export default Login;
